import React, { useState } from 'react';
import { useLogos } from '../../../context/LogoProvider';
import AlertDialog from './Shared/AlertDialog';

const UrlInputModal = ({ isOpen, onClose, onConfirm }) => {
    const { getSystemConfig } = useLogos();
    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');
    const [alertDialog, setAlertDialog] = useState({ open: false, title: "Faltan datos", message: "", variant: "warning" });

    if (!isOpen) return null;

    const handleSubmit = () => {
        if (!url.trim()) {
            setAlertDialog({
                open: true,
                title: 'Campo Requerido',
                message: 'Por favor ingresa una URL válida',
                variant: 'warning'
            });
            return;
        }

        let finalUrl = url.trim();

        // ---------------------------------------------------------
        // TRANSFORMACIONES INTELIGENTES DE URL (Smart Embeds)
        // ---------------------------------------------------------

        // 1. Detección de Canva
        // De: https://www.canva.com/design/DAF.../view...
        // A:  https://www.canva.com/design/DAF.../view?embed
        if (finalUrl.includes('canva.com/design') && !finalUrl.includes('?embed')) {
            // Eliminar parámetros existentes si los hay y agregar ?embed
            const baseUrl = finalUrl.split('?')[0];
            finalUrl = `${baseUrl}?embed`;
        }

        // 2. Detección de YouTube (Standard, Shorts, youtu.be)
        const ytRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const ytMatch = finalUrl.match(ytRegex);
        if (ytMatch && ytMatch[1]) {
            finalUrl = `https://www.youtube.com/embed/${ytMatch[1]}`;
        }

        // 3. Detección de Vimeo
        const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/;
        const vimeoMatch = finalUrl.match(vimeoRegex);
        if (vimeoMatch && vimeoMatch[1]) {
            finalUrl = `https://player.vimeo.com/video/${vimeoMatch[1]}`;
        }

        onConfirm(finalUrl, title || 'Iframe Externo');
        setUrl('');
        setTitle('');
        onClose();
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '12px',
                width: '90%',
                maxWidth: '500px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
            }}>
                <h3 style={{ marginTop: 0, color: '#1f2937', marginBottom: '1.5rem' }}>🌐 Agregar Iframe / Sitio Web</h3>

                <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', color: '#4b5563' }}>
                        URL del Sitio (src)
                    </label>
                    <input
                        type="url"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://example.com/page..."
                        style={{
                            width: '100%',
                            padding: '0.75rem',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            fontSize: '1rem'
                        }}
                    />
                    <small style={{ display: 'block', color: '#6b7280', fontSize: '0.8rem', lineHeight: '1.4', marginTop: '0.5rem' }}>
                        💡 <strong>Tip:</strong> Asegúrate de usar la versión "Embed" o "Incrustar" del enlace.
                        Sitios como Google (Drive/Docs), Canva o YouTube requieren URLs especiales para funcionar dentro de otra página.
                        <br />
                        <em>Detectamos y corregimos automáticamente enlaces de Canva y YouTube.</em>
                    </small>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                    <button
                        onClick={onClose}
                        className="btn-cancel"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="btn-action"
                    >
                        Agregar Iframe
                    </button>
                </div>
            </div>

            {/* Modal de alertas estándar LMS */}
            <AlertDialog
                open={alertDialog.open}
                title={alertDialog.title}
                message={alertDialog.message}
                variant={alertDialog.variant}
                onClose={() => setAlertDialog({ ...alertDialog, open: false })}
                buttonText="Aceptar"
            />
        </div>
    );
};

export default UrlInputModal;
